import axios from "axios";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;
const postbaseUrl = baseUrl;

class ApiService {
  getToken = () => "";

  getapi1 = async (route : string) => await axios.get(baseUrl + route);

  getapi = (route : string) =>
    new Promise((resolve, reject) => {
      axios
        .get(baseUrl + route)
        .then((response) => {
          resolve(response);
        })
        .catch(({ response }) => {
          if (response && response.status === 400) {
            resolve(response);
          }
          reject(response);
        });
    });

  authGet = (route : string, params = {}) =>
    new Promise((resolve, reject) => {
      axios
        .get(baseUrl + route, { params })
        .then((response) => {
          resolve(response);
        })
        .catch(({ response }) => {
          if (response && response.status === 400) {
            resolve(response);
          }
          reject(response);
        });
    });

  get = (route : string) =>
    new Promise((resolve, reject) => {
      axios
        .get(baseUrl + route, {
          headers: {
            Authorization: `Token ${this.getToken()}`,
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch(({ response }) => {
          if (response && response.status === 400) {
            resolve(response);
          }
          if (response && response.status === 401) {
            localStorage.clear();
            window.location.assign("/login");
            reject(response);
          }
          reject(response);
        });
    });

  authPost = (route : string, params : Record<string, any>) =>
    new Promise((resolve, reject) => {
      axios
        .post(baseUrl + route, params)
        .then((response) => {
          resolve(response);
        })
        .catch(({ response }) => {
          if (response && response.status === 400) {
            resolve(response);
          }
          if (response && response.status === 401) {
            localStorage.clear();
            window.location.assign("/login");
            reject(response);
          }
          resolve(response.data);
        });
    });

  post = (route : string, params : Record<string, any>) =>
    new Promise((resolve, reject) => {
      axios
        .post(baseUrl + route, params, {
          headers: {
            Authorization: `Token ${this.getToken()}`,
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch(({ response }) => {
          if (response && response.status === 400) {
            resolve(response);
          }
          if (response && response.status === 401) {
            localStorage.clear();
            window.location.assign("/login");
            reject(response);
          }
        });
    });

  multipart_post = (route : string, params : Record<string, any>) =>
    new Promise((resolve, reject) => {
      axios
        .post(postbaseUrl + route, params, {
          headers: {
            "Content-Type": `multipart/form-data; boundary=${params._boundary}`,
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((response) => {
          if (response && response.status === 400) {
            resolve(response);
          } else {
            reject(response);
          }
        });
    });

  put = (route : string, params : Record<string, any>) =>
    new Promise((resolve, reject) => {
      axios
        .put(baseUrl + route, params, {
          headers: {
            Authorization: `Token ${this.getToken()}`,
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch(({ response }) => {
          if (response && response.status === 400) {
            resolve(response);
          }
          if (response && response.status === 401) {
            localStorage.clear();
            window.location.assign("/login");
            reject(response);
          }
        });
    });

  delete = (route: string) =>
    new Promise((resolve, reject) => {
      axios
        .delete(baseUrl + route, {
          headers: {
            Authorization: `Token ${this.getToken()}`,
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch(({ response }) => {
          if (
            response &&
            (response.status === 400 || response.status === 403)
          ) {
            resolve(response);
          }
          if (response && response.status === 401) {
            localStorage.clear();
            window.location.assign("/login");
            reject(response);
          }
          reject(response);
        });
    });

  patch = (route : string, params : Record<string, any>) =>
    new Promise((resolve, reject) => {
      axios
        .patch(baseUrl + route, params, {
          headers: {
            Authorization: `Token ${this.getToken()}`,
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch(({ response }) => {
          if (response.status === 400) {
            resolve(response);
          }
          if (response.status === 401) {
            localStorage.clear();
            window.location.assign("/login");
            reject(response);
          }
          resolve(response);
        });
    });

  getapiNew = (route : string) =>
    new Promise((resolve, reject) => {
      axios
        .get(baseUrl + route)
        .then((response) => {
          resolve(response.data); // return the parsed data
        })
        .catch(({ response }) => {
          if (response && response.status === 400) {
            resolve(response.data);
          } else {
            reject(response);
          }
        });
    });
}

const instance = new ApiService();
export default instance;
